import React, { useState, useEffect } from "react";
import phone from "../images/prodimages/phone.svg";
import location from "../images/prodimages/location.svg";
import detectlocate from "../images/prodimages/detectlacate.svg";
import { Helmet } from "react-helmet";
import navigation from "../images/prodimages/navigation.svg";
import { api_url } from "../config/config";
import axios from "axios";
import { use } from "react";

const BranchLocations = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [pincode, setPincode] = useState("");
  const [state, setState] = useState({ filteredBranches: [], error: "", loading: false });
  const [branchData, setBranchData] = useState([]);

  // const branchData = [
  //   { 
  //     area: "MediSYS Pharmacy Head Office - Panjagutta ", 
  //     pincode: "500082", 
  //     address: "Metro pillar number 1108, Police Station, Opp:, Cross Roads, near Piller Number A1108 & A1109, Durga Nagar Colony, Panjagutta, Hyderabad, Telangana ", 
  //     contact: "077999 23501", 
  //     location: "https://g.co/kgs/4ETNhU7" 
  //   },
    
  //   { area: "MediSYS Parmacy - Lanco Hills Manikonda  ", pincode: "500104", address: " Opp:, Niharika Exotica, 2-65/2 , Lanco hills road, Khajaguda, Apartments, Manikonda, Hyderabad, Telangana ", contact: "077999 23504", location: "https://g.co/kgs/pwbp4Tj" },
    
  //   { area: "MediSYS Pharmacy - Suncity, Bandlaguda", pincode: "500091", address: "62, Westend Colony, Gandamguda, Sun City, Bandlaguda Jagir, Telangana", contact: "082476 68969", location: "https://g.co/kgs/bDwZkJW" },


  //   { area: "Mithra Medicals - Chikkadpally", pincode: "500044", address: "1-8 27/14, Chikkadpalli Rd, near Allahabad Bank, Bagh Lingampally, New Nallakunta, Hyderabad, Telangana", contact: "098498 37072", location: "https://g.co/kgs/uRqULhR" },

  //   { area: "Soma Drug Mart - Inderbagh, Koti", pincode: "500001", address: "Inder Bagh, Koti, Hyderabad, Telangana", contact: "089881 16888", location: " https://g.co/kgs/gPxULf4" },
  // ];
    const fetchBranches = async () => {
      try {
        const response = await axios.get(`${api_url}/branches`);

        const rawBranches = response.data.results || [];

        const uniqueBranches = [
          ...new Map(
            rawBranches.map((branch) => [branch.branch_id, branch])
          ).values(),
        ];

        setBranchData(uniqueBranches);
        console.log("Unique Branches:", uniqueBranches);
      } catch (error) {
        console.error("Error fetching branches:", error);
      }
    };

    useEffect(() => {
      fetchBranches();
    }, []);

  const handlePincodeChange = (e) => {
    let value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setPincode(value);
    if (value.length === 6) {
      handlePincodeSearch(value);
    } else if(value.length === 0){ 
      setState({ ...state, filteredBranches: branchData, error: "" });
    }else {
      setState({ ...state, filteredBranches: [], error: "Please Enter a Valid Pincode" });
    }
  };
  const handlePincodeSearch = (pincode) => {
    const filtered = branchData.filter(branch => branch.pincode == pincode);
    setState({ filteredBranches: filtered, error: filtered.length === 0 ? "No branches found for this pincode." : "" });
  };
  const detectMyLocation = () => {
    setState({ ...state, error: "", loading: true });

    if (!navigator.geolocation) {
      setState({ ...state, error: "Geolocation is not supported by your browser.", loading: false });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
          );
          const data = await response.json();
          const detectedPincode = data.address?.postcode;
          
          if (detectedPincode) {
            setPincode(detectedPincode);
            handlePincodeSearch(detectedPincode);
          } else {
            setState({ ...state, error: "Pincode not found for your location." });
          }
        } catch {
          setState({ ...state, error: "Failed to fetch location details." });
        } finally {
          setState(prev => ({ ...prev, loading: false }));
        }
      },
      () => {
        setState({ ...state, error: "Location access denied. Please enable location.", loading: false });
      }
    );
  };

  return (
    <div className="container mx-auto px-4 py-6 mt-20">
      <Helmet>
        <title>Branch Locations | Online Medical Store</title>
      </Helmet>

      <div className="flex items-center gap-2 my-4">
        <div className="relative flex-1 max-w-64 bg-gray-100 rounded-[30px] py-2 px-4">
          <input
            type="text"
            placeholder="Enter Pincode"
            value={pincode}
            onChange={handlePincodeChange}
            className="bg-transparent border-none focus:outline-none w-full pl-8 text-xs"
            maxLength={6}
            aria-label="Enter Pincode"
          />
          <img src={location} alt="Location Icon" className="w-4 h-4 absolute left-3 top-1/2 transform -translate-y-1/2" />
        </div>

        <button
          onClick={detectMyLocation}
          disabled={state.loading}
          className="flex items-center text-red-500 text-xs disabled:opacity-50"
        >
          <img src={detectlocate} alt="Detect Location" className="h-5 w-5 mr-1" />
          <span className="font-semibold">{state.loading ? "Detecting..." : "Detect my Location"}</span>
        </button>
      </div>

      {state.error && <p className="text-red-500 text-xs">{state.error}</p>}

       <div className="hidden sm:block">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="border border-gray-300 px-4 py-2 lg:w-[300px] md:w-[200px]">Area</th>
              <th className="border border-gray-300 px-4 py-2">Pincode</th>
              <th className="border border-gray-300 px-4 py-2">Address</th>
              <th className="border border-gray-300 px-4 py-2 lg:w-[150px] md:w-[160px]">Location</th>

              <th className="border border-gray-300 px-4 lg:w-[150px] md:w-[160px] py-2">Contact</th>
            </tr>
          </thead>
          <tbody>
            {(state.filteredBranches.length > 0 || pincode.length === 6 ? state.filteredBranches : branchData).map((branch, index) => (
              <tr key={index} className="border border-gray-300">
                <td className="border border-gray-300 px-4 py-2">{branch.area}</td>
                <td className="border border-gray-300 px-4 py-2">{branch.pincode}</td>
                <td className="border border-gray-300 px-4 py-2">
    {branch.branch_address}
</td>   
<td className="border border-gray-300 px-4 py-2">
                  <a href={branch.location} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                    View on Map
                  </a>
                </td>
                <td className="border border-gray-300 px-4 py-2">
  <a href={`tel:${branch.contact_number}`} className="text-blue-500 underline">
    {branch.contact_number}
  </a>
</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="block sm:hidden space-y-3">
        {(state.filteredBranches.length > 0 || pincode.length === 6 ? state.filteredBranches : branchData).map((branch, index) => (
          <div key={index} className="bg-white shadow-md p-3 sm:p-4 rounded-lg border flex flex-col">
            <div className="flex items-center space-x-2">
              <img src={location} alt="Location Icon" className="w-4 h-4 sm:w-5 sm:h-5" />
              <p className="text-sm sm:text-lg font-semibold">{branch.area}, {branch.pincode}</p>
            </div>
            
            <p className="text-black text-xs font-semobold sm:text-sm flex items-center mt-1">
  <img src={navigation} alt="Navigation Icon" className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
    {branch.branch_address}
</p>

<p className="text-gray-600 text-xs sm:text-sm flex items-center mt-1">
<img src={navigation} alt="Navigation Icon" className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />

<a href={branch.location} target="_blank" rel="noopener noreferrer" className="text-blue-500 underline">
                    View on Map
                  </a>
                </p>

                <p className="text-gray-600 text-xs sm:text-sm flex items-center mt-1">
  <img src={phone} alt="Phone Icon" className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
  <a href={`tel:${branch.contact_number}`} className="text-blue-500 underline">
    {branch.contact_number}
  </a>
</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BranchLocations;
